/* eslint-disable max-len */
import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import Tooltip from '../shared/tooltip';
import PromoMessage from '../../promo-message';
import InputGroup from '../../form/input-group';
import { smoothScrollToElement } from '../../../scroll';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        this.shown = this.getShown(props);

        this.state = {
            birth_time: {
                value: null,
                error: null,
            },
        };

        if (!props.has_birth_time) {
            props.trackEvent([
                'Site Interaction',
                `${props.logged_in ? 'LI' : 'LO'} Impression`,
                'Enter-Birth-Time',
            ]);

            props.trackEvent([
                'Site Interaction',
                `${props.logged_in ? 'LI' : 'LO'} Impression`,
                'Update-Report-Button',
            ]);
        }
    }

    componentDidMount() {
        if (this.props.route.match(/your-birth-chart/)) {
            smoothScrollToElement(document.querySelector(`#${this.props.route}`));
        }
    }

    shouldComponentUpdate(nextProps) {
        this.shown = this.getShown(nextProps);
    }

    componentDidUpdate() {
        if (this.props.route.match(/your-birth-chart/)) {
            smoothScrollToElement(document.querySelector(`#${this.props.route}`));
        }
    }

    render({ report, has_birth_time }) {
        if (report) {
            return (
                <ebr-landing id='your-birth-chart' className={this.shown ? 'is-shown' : null}>
                    <row className='is-wrap' id='your-birth-chart-overview'>
                        <column className='is-7 is-12-print is-12-mobile has-padding-20-desktop has-padding-20-tablet has-padding-15-mobile'>
                            <h1 className='fancy-title has-padding-5-left-mobile has-text-center-print'>{report.product.display.name}</h1>
                            <div dangerouslySetInnerHTML={{__html: report.product.birth_chart.wheel}} />
                        </column>
                        <column className='is-5 is-12-print is-12-mobile has-padding-20'>
                            <h1 className='fancy-title'>{this.props.renderName()}</h1>
                            <p className='has-margin-0'>{this.props.renderBirthDate()} {this.props.renderBirthTime('Landing')}</p>
                            <p>{this.props.renderBirthLocation()}</p>
                            <row className={has_birth_time ? '' : 'is-hidden-print'}>
                                {this.renderSign('SUN')}
                                {this.renderSign('MOO')}
                                {this.renderSign('1#C')}
                            </row>
                            {this.renderBirthTimeUpdate()}
                            {this.renderMainMessaging()}
                            {this.renderPrintSignMessaging()}
                        </column>
                    </row>
                    <row className='is-wrap'>
                        {this.renderPlanetTable()}
                        {this.renderAspectGrid()}
                        <column className='is-12-print is-visible-print has-padding-100' />
                        {this.renderAspectTable()}
                        <column className='is-6 is-12-mobile is-6-print has-padding-20'>
                            {this.renderAspectKey()}
                            {this.renderHousePositions()}
                        </column>
                    </row>
                    {this.renderLandingPromoMessage()}
                </ebr-landing>
            );
        }

        return null;
    }

    renderSign = (type) => {
        let symbol = '?';
        let sign = 'Unknown';
        const type_text = {
            'SUN': 'Sun',
            'MOO': 'Moon',
            '1#C': 'Rising',
        };

        if (this.props.report.product.data['natal-1'][type]) {
            symbol = this.props.report.product.data.astrology_key.symbols[this.props.report.product.data['natal-1'][type].position.sign];
            sign = this.props.report.product.data.astrology_key.sign[this.props.report.product.data['natal-1'][type].position.sign];
        }

        const className = symbol == '?' ? 'symbol has-text-boulder' : `symbol has-text-${sign.toLowerCase()}`;

        return (
            <column className='is-4 has-text-center'>
                <h1 className={className}>{symbol}</h1>
                <p>{sign}<br />{type_text[type]}</p>
            </column>
        );
    }

    renderBirthTimeUpdate = () => {
        if (
            !this.props.has_birth_time
            &&
            this.props.logged_in
            &&
            this.props.user.member_uuid == this.props.report.member_uuid
        ) {
            return (
                <row className='is-wrap is-hidden-print'>
                    <column className='is-6 is-12-mobile has-padding-10-right'>
                        <InputGroup
                            type='time'
                            name='birth_time'
                            label='Enter Your Birth Time:'
                            placeholder='SELECT TIME'
                            value={this.state.birth_time.value}
                            error={this.state.birth_time.error}
                            onInput={this.setBirthTime}
                            onFocus={() => {
                                this.props.trackEvent([
                                    'Site Interaction',
                                    `${this.props.logged_in ? 'LI' : 'LO'} Click`,
                                    'Enter-Birth-Time',
                                ]);
                            }}
                        />
                    </column>
                    <column className='is-6 is-12-mobile has-padding-25-top-desktop has-padding-25-top-tablet has-padding-20-bottom-mobile'>
                        <button className='button-pink' onClick={this.addBirthTime}>
                            {this.props.submitting ? 'SUBMITTING...' : 'UPDATE MY REPORT'}
                        </button>
                    </column>
                </row>
            );
        }

        return null;
    }

    renderPlanetTable = () => {
        if (this.props.report.product.birth_chart.planet_table) {
            return (
                <column
                    className='is-6 is-12-mobile is-6-print has-padding-20'
                    id='your-birth-chart-planetary-positions'
                >
                    <h1 className='fancy-title'>
                        <span className='has-padding-20-right'>Planetary Positions</span>
                        <Tooltip content={this.props.report.product.display.sections[1].help.planets.body} />
                    </h1>
                    <div dangerouslySetInnerHTML={{__html: this.props.report.product.birth_chart.planet_table}} />
                </column>
            );
        }

        return null;
    }

    renderAspectGrid = () => {
        if (this.props.report.product.birth_chart.aspect_grid) {
            return (
                <column
                    className='is-6 is-12-mobile is-6-print has-padding-20'
                    id='your-birth-chart-aspects'
                >
                    <h1 className='fancy-title'>
                        <span className='has-padding-20-right'>Aspects</span>
                        <Tooltip content={this.props.report.product.display.sections[1].help.aspects.body} />
                    </h1>
                    <div dangerouslySetInnerHTML={{__html: this.props.report.product.birth_chart.aspect_grid}} />
                </column>
            );
        }

        return null;
    }

    renderAspectTable = () => {
        if (this.props.report.product.birth_chart.aspect_table) {
            return (
                <column
                    className='is-6 is-12-mobile is-6-print has-padding-20'
                    id='your-birth-chart-major-aspects'
                >
                    <h1 className='fancy-title'>
                        <span className='has-padding-20-right'>Major Aspects</span>
                        <Tooltip content={this.props.report.product.display.sections[1].help.aspects.body} />
                    </h1>
                    <div dangerouslySetInnerHTML={{__html: this.props.report.product.birth_chart.aspect_table}} />
                </column>
            );
        }

        return null;
    }

    renderAspectKey = () => {
        if (this.props.report.product.birth_chart.aspect_key) {
            return [
                <h1 className='fancy-title' id='your-birth-chart-aspect-key'>
                    <span className='has-padding-20-right'>Aspect Key</span>
                    <Tooltip content={this.props.report.product.display.sections[1].help.aspect_key.body} />
                </h1>,
                <div dangerouslySetInnerHTML={{__html: this.props.report.product.birth_chart.aspect_key}} />,
            ];
        }

        return null;
    }

    renderHousePositions = () => {
        if (this.props.report.product.birth_chart.house_table) {
            return [
                <h1 className='fancy-title' id='your-birth-chart-house-positions'>
                    <span className='has-padding-20-right'>House Positions</span>
                    <Tooltip content={this.props.report.product.display.sections[1].help.houses.body} />
                </h1>,
                <div dangerouslySetInnerHTML={{__html: this.props.report.product.birth_chart.house_table}} />,
            ];
        }

        return null;
    }

    renderMainMessaging = () => {
        if (this.props.is_sample) {
            return (
                <p className='is-hidden-print'>
                    <PromoMessage placement='in-product' tags='ebrsample,main' />
                </p>
            );
        }

        return this.props.report.product.display.sections[1].block[0].content[0].body.map(p => <p className='is-hidden-print'>{p}</p>);
    }

    renderPrintSignMessaging = () => {
        if (this.props.report.product.display.sections[1].block[1]) {
            if (
                this.props.report.product.display.sections[1].block[1].content[0].body
                &&
                this.props.report.product.data['natal-1'].SUN
            ) {
                const symbol = this.props.report.product.data.astrology_key.symbols[this.props.report.product.data['natal-1'].SUN.position.sign];
                const sign = this.props.report.product.data.astrology_key.sign[this.props.report.product.data['natal-1'].SUN.position.sign];

                return (
                    <div className='is-visible-print'>
                        <h1 className='fancy-title'>
                            <span className={`symbol has-text-${sign.toLowerCase()}`}>{symbol}</span>
                            {sign} Sun
                        </h1>
                        {this.props.report.product.display.sections[1].block[1].content[0].body.map(p => <p>{p}</p>)}
                    </div>
                );
            }
        }

        return null;
    }

    renderLandingPromoMessage = () => {
        const product = this.props.is_sample ? 'ebrsample' : 'ebr';

        return (
            <p className='has-margin-20-top has-text-center has-padding-15-left has-pading-15-right landing-promo'>
                <PromoMessage placement='in-product' tags={`${product},landing`} />
            </p>
        );
    }

    setBirthTime = (e) => {
        this.setState({
            birth_time: {
                value: e.target.value,
                error: null,
            },
        });
    }

    addBirthTime = () => {
        if (!this.state.birth_time.value) {
            this.setState({
                birth_time: {
                    value: null,
                    error: 'Please enter your Birth Time',
                },
            });
        } else if (!this.state.birth_time.value.match(/^(?:(?:0?[0-9]|1[0-2]):[0-5][0-9] [aApP][mM]|(?:[01][0-9]|2[0-3]):[0-5][0-9])$/)) {
            this.setState({
                birth_time: {
                    value: this.state.birth_time.value,
                    error: 'Invalid Birth Time - HH:MM AM/PM',
                },
            });
        } else {
            this.props.trackEvent([
                'Site Interaction',
                `${this.props.logged_in ? 'LI' : 'LO'} Click`,
                'Update-Report-Button',
            ]);

            this.props.addBirthTime({
                product_slug: this.props.report.constants.product_slug,
                person_1_birth_time: this.state.birth_time.value,
            });
        }
    }

    getShown = (props) => {
        return !props.route || (!props.route.match(/^your-report/) && !props.route.match(/^glossary/));
    }
}

const mapStateToProps = (state) => ({
    report: state.report,
    route: state.route,
    is_sample: state.report && state.report.product_code && state.report.product_code == 'essential-birth-sample',
    has_birth_time: state.report && state.report.product && state.report.product.restrictions
        && state.report.product.restrictions[0] && state.report.product.restrictions[0] == 'has_birth_time',
    submitting: state.product && state.product.submitting,
    logged_in: state.user && state.user.logged_in,
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    addBirthTime: (payload) => dispatch({ type: 'report:add-birth-time', payload: payload }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
